import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PlaygroundCollection } from 'src/app/core/domain/playground-collection.model';

/** Calls Portal.HttpFunctions' /api/developer/collections — JWT-authenticated, same as
 * TokenApiService. Collections are tenant-wide (any team member can load/reuse them),
 * per the concept doc's decision to keep the Playground's saved requests shared rather
 * than per-user. */
@Injectable({ providedIn: 'root' })
export class CollectionApiService {
  private readonly base = `${environment.apiUrl}/developer/collections`;

  constructor(private http: HttpClient) { }

  list(): Observable<PlaygroundCollection[]> {
    return this.http.get<PlaygroundCollection[]>(this.base);
  }

  create(name: string, requestJson: string): Observable<PlaygroundCollection> {
    return this.http.post<PlaygroundCollection>(this.base, { name, requestJson });
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
